import React, { useContext, useState } from 'react';
import {
  RadioGroupField,
  SelectField
} from '@trp-beacon-ui-kit/react-controls';
import config from '../../config';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './BrokerageAccountSelectionScreen.css';
import chLeft from '../../images/icon_chevron_left.svg';
import ApplicationInProgressModal from '../../components/ApplicationInProgressModal/ApplicationInProgressModal';

const brkAccountTypeOptions = {
  RETIREMENT: [
    {
      brokerageKey: 'traditional-ira',
      name: 'Brokerage Traditional IRA'
    },
    {
      brokerageKey: 'roth-ira',
      name: 'Brokerage Roth IRA'
    }
  ],
  ROLLOVER: [
    {
      brokerageKey: 'rollover-ira',
      name: 'Brokerage Rollover IRA (External to TRP)'
    },
    {
      brokerageKey: 'roth-rollover-ira',
      name: 'Brokerage Roth Rollover IRA (External to TRP)'
    }
  ],
  TAXABLE: [
    {
      brokerageKey: 'individual',
      name: 'Brokerage Individual Owner'
    },
    {
      brokerageKey: 'joint',
      name: 'Brokerage Joint Owner'
    },
    {
      brokerageKey: 'ugma-utma',
      name: 'Brokerage UGMA/UTMA'
    }
  ]
};

const BrokerageAccountSelectionScreen = () => {
  const { next, formProps } = useContext(FlowContext);

  const [investmentGoal, setInvestmentGoal] = useState();
  const [applicationType, setApplicationType] = useState();
  const [isInvestmentGoalSelected, setIsInvestmentGoalSelected] = useState(
    false
  );
  const [isAccountTypeSelected, setIsAccountTypeSelected] = useState(false);

  const handleGoalChange = event => {
    setInvestmentGoal(event.target.value);
    setIsInvestmentGoalSelected(true);
    // Clear the selected application type when account type is selected
    setApplicationType(null);
    return setIsAccountTypeSelected(false);
  };

  const handleAppTypeChange = event => {
    setApplicationType(event.target.value);
    return setIsAccountTypeSelected(true);
  };

  const handleBack = () => {
    window.location.href = `${config(
      'internalReturnUrlPrefix'
    )}personal-investing/tools/nasu/front-office/account-finder`;
  };

  return (
    <>
      <div className="btn-container">
        <MFBeaconButton
          variant="tertiary"
          size="jumbo"
          data-name="brkgAcctBackBtn"
          onClick={handleBack}
          label="Back"
          icon-align="left"
          className="breadcrumb">
          <img slot="icon" src={chLeft} alt="back icon" />
        </MFBeaconButton>
      </div>
      <div className="container">
        <div className="title-wrapper">
          <h1>Open a Brokerage Account</h1>
          <p>
            After selecting an investment goal, you&apos;ll see the client
            application web view.
          </p>
        </div>
        <div className="goal-option-input">
          <RadioGroupField
            name="investmentGoal"
            {...formProps.investmentGoal}
            title="What is the client's investment goal for the new account?"
            options={[
              {
                title: 'Saving for retirement',
                value: 'RETIREMENT'
              },
              {
                title: 'General investing or personal investing',
                value: 'TAXABLE'
              },
              {
                title: 'Initiating a rollover',
                value: 'ROLLOVER'
              }
            ]}
            onChange={handleGoalChange}
          />
        </div>
        {investmentGoal && (
          <div className="app-type-input">
            <SelectField
              name="applicationType"
              data-name="applicationType"
              {...formProps.applicationType}
              title="Select an account application:"
              onChange={handleAppTypeChange}>
              <option hidden value="">
                Select an account application
              </option>
              {brkAccountTypeOptions[investmentGoal].map(app => {
                return (
                  <option
                    data-testid={app.name}
                    key={app.name}
                    value={app.brokerageKey}>
                    {app.name}
                  </option>
                );
              })}
            </SelectField>
          </div>
        )}
      </div>

      <div className="btn-container">
        <MFBeaconButton
          variant="primary"
          size="jumbo"
          data-name="brkgAcctContinueBtn"
          onClick={() => next(applicationType)()}
          disabled={!(isInvestmentGoalSelected && isAccountTypeSelected)}
          label="Continue"
        />
      </div>
      <ApplicationInProgressModal />
      <style jsx>{styles}</style>
    </>
  );
};

export default BrokerageAccountSelectionScreen;
